import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { updatePlanSelection } from 'src/useCase/userTreatment'
import { getInfo } from 'src/useCase/user'
import { PATH as PATH_CHAT } from 'src/pages/chat/Chat'

interface PlanSelectionOptions {
  planId?: string | number | null
  waitDoctorProposal?: boolean
}

export default function usePlanSelection(
  userTreatmentId?: string | number | null,
) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const handlePlanSelection = useCallback(
    async ({
      planId = null,
      waitDoctorProposal = false,
    }: PlanSelectionOptions) => {
      if (!userTreatmentId) return
      try {
        setLoading(true)
        const payload: any = {
          id: userTreatmentId,
          has_selected_plan: !waitDoctorProposal,
        }

        if (planId !== null && planId !== undefined) {
          payload.plan_id = planId
        }

        await dispatch(updatePlanSelection(payload) as any)

        await dispatch(
          getInfo({
            with: 'userTreatments',
          }) as any,
        )

        if (waitDoctorProposal) {
          navigate(PATH_CHAT)
        }
      } finally {
        setLoading(false)
      }
    },
    [dispatch, userTreatmentId, navigate],
  )

  return { handlePlanSelection, loading }
}
